import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=e8676ba6&"
import script from "./Perfil.vue?vue&type=script&lang=js&"
export * from "./Perfil.vue?vue&type=script&lang=js&"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=e8676ba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports